// extracted by mini-css-extract-plugin
module.exports = {"buttonRefuse":"styles_buttonRefuse__2SHGF","buttonConfirm":"styles_buttonConfirm__1yA-6","buttonsContainer":"styles_buttonsContainer__250of"};